import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Car, LogOut, Truck, Settings, Map, Users, ScrollText, CreditCard, IdCard } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const Sidebar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const links = [
    { to: "/app", label: "Tableau de bord", icon: LayoutDashboard, end: true },
    { to: "/vehicules", label: "Véhicules", icon: Car, end: false },
    { to: "/conducteurs", label: "Conducteurs", icon: IdCard, end: false },
    { to: "/carte", label: "Carte flotte", icon: Map, end: false },
    ...(user?.role === "admin" ? [
      { to: "/utilisateurs", label: "Utilisateurs", icon: Users, end: false },
      { to: "/journal", label: "Journal", icon: ScrollText, end: false },
      { to: "/facturation", label: "Facturation", icon: CreditCard, end: false },
    ] : []),
    { to: "/parametres", label: "Paramètres", icon: Settings, end: false },
  ];

  return (
    <aside
      data-testid="sidebar"
      className="fixed left-0 top-0 h-screen w-64 bg-white border-r-2 border-slate-900 flex flex-col z-30"
    >
      <div className="px-6 py-7 border-b-2 border-slate-900">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl bg-[#4F46E5] border-2 border-slate-900 flex items-center justify-center nb-shadow">
            <Truck className="text-white" strokeWidth={2.5} size={22} />
          </div>
          <div>
            <h1 className="font-heading font-black text-lg leading-none tracking-tight">
              Mobicars<span className="text-[#4F46E5]">VSD</span>
            </h1>
            <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500 mt-1">
              Suivi de flotte
            </p>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-2">
        {links.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl font-bold text-sm transition-all ${
                isActive
                  ? "bg-[#FBBF24] border-2 border-slate-900 nb-shadow"
                  : "border-2 border-transparent hover:border-slate-900 hover:bg-slate-50"
              }`
            }
            data-testid={`nav-${to === "/app" ? "dashboard" : to.replace("/", "")}`}
          >
            <Icon strokeWidth={2.5} size={20} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="px-4 py-5 border-t-2 border-slate-900">
        <div className="mb-3 px-2">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-400">Connecté</p>
          <p className="text-sm font-semibold truncate" data-testid="sidebar-user-email">
            {user?.email}
          </p>
        </div>
        <button
          onClick={handleLogout}
          data-testid="logout-button"
          className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-white nb-btn font-bold text-sm text-red-600"
        >
          <LogOut strokeWidth={2.5} size={18} />
          Déconnexion
        </button>
      </div>
    </aside>
  );
};
